import React, { useEffect, useState } from 'react'

// 同じ座標（丸め後）への問い合わせはキャッシュし、Geocoding APIの呼び出し回数を抑える
const addressCache = new Map();

// GPSの微小な揺らぎを吸収しつつキャッシュキーにするため、約1m単位に丸める
const roundCoord = (value) => Math.round(value * 100000) / 100000;

// 緯度経度から住所を逆引きする（Google Geocoding API）
const fetchAddress = async (lat, lng) => {
    const cacheKey = roundCoord(lat) + ',' + roundCoord(lng);

    if(addressCache.has(cacheKey)) {
        return addressCache.get(cacheKey);
    }

    const url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lng + '&language=ja&key=' + process.env.REACT_APP_API_KEY;
    const response = await fetch(url);
    const data = await response.json();

    const address = (data.status === 'OK' && data.results && data.results.length > 0)
        ? data.results[0].formatted_address
        : null;

    addressCache.set(cacheKey, address);
    return address;
};

// 緯度経度の座標を、Geocodingで取得した住所表示に置き換える（取得できない場合は座標にフォールバック）
const AddressLabel = ({ lat, lng }) => {
    const [address, setAddress] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if(lat === undefined || lat === null || lng === undefined || lng === null) {
            setLoading(false);
            setAddress(null);
            return;
        }

        let cancelled = false;
        setLoading(true);

        fetchAddress(lat, lng)
            .then((result) => {
                if(!cancelled) setAddress(result);
            })
            .catch((error) => {
                console.error('住所の取得に失敗しました:', error);
                if(!cancelled) setAddress(null);
            })
            .finally(() => {
                if(!cancelled) setLoading(false);
            });

        return () => { cancelled = true; };
    }, [lat, lng]);

    if(loading) {
        return <span>住所を取得中…</span>;
    }

    // 取得できない場合は座標を表示
    return <span>{address || ('(' + lat + ', ' + lng + ')')}</span>;
};

export default AddressLabel
